import _ from 'lodash';
import moment from 'moment-timezone';
import { CAMPAIGN_FORM_KEYS as FK, PRESENTATION_TYPES } from 'dash-front/constants';
import { triggerTypesMap } from 'dash-front/triggerConstants';
import store from 'dash-front/createStore';
import { presence } from 'dash-front/helpers/validation';
import { isNullOrUndefined } from 'dash-front/helpers';

const WIDGET = FK.WIDGET;
const ADD_PARAMS = WIDGET.PARAMS.ADDITIONAL;
const TIME_FORMAT = 'HH:mm';
const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm[Z]';

export const defValidate = () => {
    const errors = {};
    // if (!_.get(values, 'rules.length')) {
    //     errors['rules'] = 'At least one rule should be present';
    // }
    return errors;
};

const transformConditionToServer = (condition, allValues) => {
    if (!_.isObject(condition)) {
        return condition;
    }
    return Object.keys(condition).reduce((acc, cur) => {
        switch (cur) {
            case 'time': {
                const { timezone } = allValues;
                const userTime = condition[cur];
                const utcTime = moment
                    .tz(userTime, TIME_FORMAT, timezone)
                    .utc()
                    .format(TIME_FORMAT);
                acc[cur] = utcTime;
                break;
            }
            case 'dateTime': {
                const { timezone } = allValues;
                const userTime = condition[cur];
                const utcTime = moment
                    .tz(userTime, DATE_TIME_FORMAT, timezone)
                    .utc()
                    .format(DATE_TIME_FORMAT);
                acc[cur] = utcTime;
                break;
            }
            default:
                acc[cur] = condition[cur];
        }
        return acc;
    }, {});
};

export const mapData = values => {
    const {
        user: { username, client }
    } = store.getState();
    const copy = _.merge({}, values);
    const { timezone } = copy;
    copy.startDate = copy.startDate
        ? moment(copy.startDate)
              .tz(timezone)
              .startOf('d')
              .utc()
              .toDate()
        : null;
    copy.endDate = copy.endDate
        ? moment(copy.endDate)
              .tz(timezone)
              .endOf('d')
              .utc()
              .toDate()
        : null;
    if (copy.messengerNotifications) {
        copy.notificationsTo = [
            ...copy.notificationsTo,
            ...copy.messengerNotifications.map(n => ({
                value: n.userRef,
                userName: n.userName,
                userId: n.userId,
                userPhoto: n.userPhoto,
                type: 'messenger'
            }))
        ];
    }
    if (!Array.isArray(copy.rules)) {
        copy.rules = [];
    }
    copy.rules.forEach(rule => {
        rule.conditions = rule.conditions.map(condition => transformConditionToServer(condition, values));
        rule.presentation.type = PRESENTATION_TYPES.WIDGET;
        const { additional = [], ...rest } = rule.presentation;
        rule.presentation = rest;
        rule.presentation.params = {
            username,
            client,
            theme: 'default',
            template: rule.presentation.params.template,
            ...additional.reduce((acc, cur) => {
                if (!cur[ADD_PARAMS.BY_TRIGGER]) {
                    const customVal = cur[ADD_PARAMS.CUSTOM_VALUE];
                    const isEmpty = isNullOrUndefined(customVal);
                    acc[cur.key] = isEmpty ? '' : customVal;
                }
                return acc;
            }, {})
        };
        rule.presentation[WIDGET.TRIGGER_PARAMS.SECTION] = additional.reduce((acc, cur) => {
            if (cur[ADD_PARAMS.BY_TRIGGER]) {
                acc[cur.key] = cur[ADD_PARAMS.VALUE];
            }
            return acc;
        }, {});
    });
    return copy;
};

export const validateConditions = (values, triggerType) => {
    const trigger = triggerTypesMap[triggerType];
    const requiredConditions = _.get(trigger, 'conditions', []).filter(e => e.required);
    const formConditions = _.get(values, 'conditions', [{}]);
    const result = formConditions.reduce((errors, formCondition, formIndex) => {
        requiredConditions.forEach(({ name }) => {
            const formValue = _.get(formCondition, name);
            const validationResult = presence(formValue);
            if (validationResult) {
                errors = _.set(errors, formIndex + '.' + name, validationResult);
            }
        });
        return errors;
    }, {});
    if (Object.keys(result).length) {
        return { conditions: result };
    }
    return {};
};

const WIDGET_NAME = FK.WIDGET.SECTION + '.' + FK.WIDGET.NAME;
const WIDGET_TEMPLATE = FK.WIDGET.SECTION + '.' + FK.WIDGET.PARAMS.SECTION + '.' + FK.WIDGET.PARAMS.TEMPLATE;

export const validateWizzard = values => {
    let res = {};
    const triggerType = values[FK.RULES.KEY];
    if (!triggerType) {
        res[FK.RULES.KEY] = 'Required';
    } else {
        res = { ...validateConditions(values, triggerType), ...res };
    }
    if (!_.get(values, WIDGET_NAME)) {
        _.set(res, WIDGET_NAME, 'Required');
    }
    if (!_.get(values, WIDGET_TEMPLATE)) {
        _.set(res, WIDGET_TEMPLATE, 'Required');
    }
    return res;
};

/**
 * Resolves value for props map form (3 step)
 * @param {Array} widgetProps
 * @param {Object} triggerPayloadMap Payload that is returned by trigger
 * @returns {Array}
 */
export const getWidgetParamsInitValue = (widgetProps, triggerPayloadMap) =>
    widgetProps.filter(el => el.key !== 'template').map(prop => {
        const { key, defaultValue } = prop;
        const value = triggerPayloadMap[key];
        if (value !== undefined) {
            return {
                [FK.WIDGET.PARAMS.ADDITIONAL.KEY]: key,
                [FK.WIDGET.PARAMS.ADDITIONAL.VALUE]: value,
                [FK.WIDGET.PARAMS.ADDITIONAL.BY_TRIGGER]: true
            };
        }
        return {
            [FK.WIDGET.PARAMS.ADDITIONAL.KEY]: key,
            [FK.WIDGET.PARAMS.ADDITIONAL.VALUE]: 'manual',
            [FK.WIDGET.PARAMS.ADDITIONAL.BY_TRIGGER]: false,
            [FK.WIDGET.PARAMS.ADDITIONAL.CUSTOM_VALUE]: defaultValue
        };
    });

export const generateRoutingKey = (triggerType, conditions = {}) => {
    const triggerConditions = _.get(triggerTypesMap[triggerType], 'conditions', []);
    return triggerConditions.reduce((acc, cur) => {
        const currentVal = conditions[cur.name];
        return acc + '.' + currentVal;
    }, triggerType);
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/schema.js
 **/